import api from './api';

export const getScheduleTemplate = () => api.get('/schedule/template');

export const getProjectSchedule = (projectId) => api.get(`/schedule/projects/${projectId}`);

export const createProjectSchedule = (projectId, data) => api.post(`/schedule/projects/${projectId}`, data);

export const updateProjectSchedule = (projectId, data) => api.put(`/schedule/projects/${projectId}`, data);

export const updateScheduleStep = (projectId, stepId, data) =>
  api.put(`/schedule/projects/${projectId}/steps/${stepId}`, data);

export const freezeSchedule = (projectId) => api.post(`/schedule/projects/${projectId}/freeze`);

export const getMyScheduleTasks = (params = {}) => api.get('/schedule/my-tasks', { params });

export const updateScheduleTask = (taskId, data) => api.put(`/schedule/tasks/${taskId}`, data);

// responsibleId null = back to the department head.
export const setTaskResponsible = (projectId, taskId, responsibleId) =>
  api.put(`/schedule/projects/${projectId}/tasks/${taskId}/responsible`, { responsible_id: responsibleId });

// PM weekly review + portfolio (schedule_review_routes.py)
export const getSchedulePortfolio = () => api.get('/schedule/portfolio');

export const getMyReviews = () => api.get('/schedule/reviews');

export const getProjectReview = (projectId) => api.get(`/schedule/projects/${projectId}/review`);

export const saveProjectReview = (projectId, data) => api.put(`/schedule/projects/${projectId}/review`, data);

export const remindDepartment = (projectId, departmentId) =>
  api.post(`/schedule/projects/${projectId}/review/remind/${departmentId}`);

// Timeline revisions (schedule_revision_routes.py)
export const getRevisionApprovers = (projectId) => api.get(`/schedule/projects/${projectId}/revisions/approvers`);

export const previewRevision = (projectId, data) => api.post(`/schedule/projects/${projectId}/revisions/preview`, data);

export const raiseRevision = (projectId, data) => api.post(`/schedule/projects/${projectId}/revisions`, data);

export const uploadRevisionDocument = (projectId, revisionId, file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(`/schedule/projects/${projectId}/revisions/${revisionId}/document`, form);
};

export const downloadRevisionDocument = (projectId, revisionId, documentId) =>
  api.get(`/schedule/projects/${projectId}/revisions/${revisionId}/documents/${documentId}`, { responseType: 'blob' });

export const decideRevision = (projectId, revisionId, approve, note) =>
  api.post(`/schedule/projects/${projectId}/revisions/${revisionId}/decision`, { approve, note });

// Monday management email (schedule_report_routes.py)
export const getReportRecipients = () => api.get('/schedule/report/recipients');

export const addReportRecipient = (employeeId) => api.post('/schedule/report/recipients', { employee_id: employeeId });

export const removeReportRecipient = (employeeId) => api.delete(`/schedule/report/recipients/${employeeId}`);

export const sendReportPreview = () => api.post('/schedule/report/preview');
